import { render, staticRenderFns } from "./OrderDone.vue?vue&type=template&id=55948a2c&"
import script from "./OrderDone.vue?vue&type=script&lang=js&"
export * from "./OrderDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports